import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_18: FaireProductEntity = {
  token: "sweet-wink-18",
  type: "product",
  name: "XOXO Sequin Patch Valentine's Day Women's Sweatshirt - Ballet",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/237103c7cbc27f796c7f7778053931b734b792d77907c609290f43ad27a43ca8.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 24,
  msrpDollars: 48,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
